import { ChronicDisease } from '@dreryk/egabinet-patient-medical-information-frontend-api';

import { createTranslatedText } from '@dreryk/react-common';
import { MedicalDataIcon, SidePanelList } from '@dreryk/react-components';

import { useChronicDiseaseSidePanelListItems } from './ChronicDiseaseSidePanelList.hooks';

type ChronicDiseaseSidePanelListProps = {
   readonly chronicDiseases: ChronicDisease[];
   readonly onMedicalDataAccessAuthorizationUpdate: VoidFunction;
};

export const ChronicDiseaseSidePanelList = (props: ChronicDiseaseSidePanelListProps): JSX.Element => {
   return (
      <SidePanelList
         icon={<MedicalDataIcon />}
         items={useChronicDiseaseSidePanelListItems(
            props.chronicDiseases,
            props.onMedicalDataAccessAuthorizationUpdate
         )}
         noItemsMessage={createTranslatedText('')}
      />
   );
};
